import React from 'react';
export function SocialProof() {
  const pilotFeatures = ['Maps your brand standards', 'Governs your prompt structures', 'Enforces scoring thresholds', 'Flags weak messaging', 'Tracks conversational impact', 'Surfaces performance shifts'];
  return <section className="w-full py-16 md:py-24 px-4 bg-muted/30" data-id="element-423">
      <div className="container max-w-5xl mx-auto" data-id="element-424">
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-425">
          {/* Mascot */}
          <div className="flex-shrink-0" data-id="element-426">
            <img src="https://cdn.magicpatterns.com/uploads/azCoZcVLmtTTDNhaZ94LXY/wisepilot-mascot.svg" alt="WisePilot Mascot" className="w-48 h-48 md:w-64 md:h-64" data-id="element-427" />
          </div>

          {/* Content */}
          <div className="flex-1 space-y-6" data-id="element-428">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground leading-tight" data-id="element-429">
              Meet the Pilot.
            </h2>

            <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-430">
              WisePilot isn't a dashboard.
            </p>

            <p className="text-xl font-semibold text-foreground leading-relaxed" data-id="element-431">
              It's an autonomous marketing copilot that:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-432">
              {pilotFeatures.map((feature, index) => <div key={index} className="flex items-center gap-2 text-base text-muted-foreground" data-id="element-433">
                  <div className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--brand-blue-light))] dark:bg-[hsl(var(--brand-blue-dark))] flex-shrink-0" data-id="element-434" />
                  <span data-id="element-435">{feature}</span>
                </div>)}
            </div>

            <div className="pt-4 space-y-3" data-id="element-436">
              <p className="text-lg font-semibold text-foreground leading-relaxed" data-id="element-437">
                It doesn't just generate.
              </p>
              <p className="text-lg font-semibold text-foreground leading-relaxed" data-id="element-438">
                It monitors. It measures. It recalibrates.
              </p>
              <p className="text-xl font-bold text-[hsl(var(--brand-blue-light))] dark:text-[hsl(var(--brand-blue-dark))] leading-relaxed" data-id="element-439">
                Your marketing stack gets a control layer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}